module.exports = __webpack_public_path__ + "static/9-049e8a7f23348b1c6d3bf99817de250a.jpg";